import {cDisplay} from '../creator/cDisplay'
import { cGame } from '../creator/cGame';
import { cText } from '../creator/cGameObjects/cText';
import {cScene} from '../creator/cScene'
import { maxCoins } from '../creator/cDisplayObjects/EvaluationCard'


export class diplomaDisplay extends cDisplay {

  init(){
    super.init()
    console.log('DIPLOMA Result');
    (this.scene as cScene).ev.addListener('action',(a,b,c)=>{
    })
  }


  buildScene(){
    super.buildScene();

    var opt = (this.scene as cScene).sceneData.options

    switch (opt.gamesection){
      case 'wahl':
        this.buildScene_wahlen()
        break;
      default:
        this.buildScene_grundrechte();
        break;
    }   
  }


  buildScene_wahlen(){    

    var scoreing = cGame.current.state.get('2::scoring',{})
    var total = Object.keys(scoreing).reduce((acc,val)=>{
      console.log(val,scoreing[val])
      return acc+scoreing[val]
    },0);
    var sticker_count = 0;
    var maxCoins = 50;

    (this.getByName('text_score') as cText).textdata = total+'';
    
    var stickerTxt = (this.getByName('static_txt_sticker') as cText);
    stickerTxt.visible = false

    var s = this.getByName('static_txt_total').modules.data._extraData;
    (this.getByName('static_txt_total') as cText).textdata = String(s.text).replace('[max]', String(maxCoins) );
    (this.getByName('static_txt_sticker') as cText).visible = false

    if (scoreing < 20){
      console.log('s1')
      this.getByName('diploma_title').setFrame(0);
      (this.getByName('diploma_title_txt') as cText).textdata = 'Kleiner Grünschnabel';
    }else if (scoreing < 35){
      console.log('s2')
      this.getByName('diploma_title').setFrame(1);
      (this.getByName('diploma_title_txt') as cText).textdata = 'Furchtloser Verfassungsforscher';
    }else{
      console.log('s3')
      this.getByName('diploma_title').setFrame(2);
      (this.getByName('diploma_title_txt') as cText).textdata = 'Helles Köpfchen';
    }

  }

  buildScene_grundrechte(){    
    

    const stickers = [
      "sticker_chemnitz",
      "sticker_dorrheeme",
      "sticker_dresden",
      "sticker_elbeschiffart",
      "sticker_glueckauf",
      "sticker_lausitz",
      "sticker_love_leibzig",
      "sticker_moritzburg",
      "sticker_nussknacker",
      "sticker_sachsen"
    ]

    var sticker_count = 0;
    stickers.forEach((el)=>{
      console.log(el);
      var st = cGame.current.state.get(el,0);
      sticker_count += (st == 1) ? 1 :0
    });

    var scores = cGame.current.state.get('scoring',{});

    var globalScore:number = 0;
    Object.keys(scores).map( (k)=>{ 
      globalScore += scores[k]; 
      return null 
    });    

    (this.getByName('text_score') as cText).textdata = globalScore+'';
  
  
  
    var stickerTxt = (this.getByName('static_txt_sticker') as cText);
    stickerTxt.textdata = String(stickerTxt.modules.data._extraData.text).replace('[count]', String(sticker_count));

    var s = this.getByName('static_txt_total').modules.data._extraData;
    (this.getByName('static_txt_total') as cText).textdata = String(s.text).replace('[max]', String(maxCoins) );
    

    if (globalScore < maxCoins / 3){
      console.log('s1')
      this.getByName('diploma_title').setFrame(0);
      (this.getByName('diploma_title_txt') as cText).textdata = 'Kleiner Grünschnabel';
    }else if (globalScore < maxCoins / 3 *2){
      console.log('s2')
      this.getByName('diploma_title').setFrame(1);
      (this.getByName('diploma_title_txt') as cText).textdata = 'Furchtloser Verfassungsforscher';
    }else{
      console.log('s3')
      this.getByName('diploma_title').setFrame(2);
      (this.getByName('diploma_title_txt') as cText).textdata = 'Helles Köpfchen';
    }


  }

}

